// Axis-separated collision resolution. Given current feet (fx, fy), a desired delta
// (dx, dy), and a blocked(x, y) predicate, accept each axis independently so the avatar
// slides along an obstacle edge instead of sticking. Returns the resolved feet {x, y}.
export function slideMove(fx, fy, dx, dy, blocked) {
  let x = fx;
  let y = fy;
  if (dx !== 0 && !blocked(fx + dx, y)) x = fx + dx;
  if (dy !== 0 && !blocked(x, fy + dy)) y = fy + dy;
  return { x, y };
}
